import React from 'react';
import { useParams } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { ReviewQueueScreen } from './ReviewQueueScreen';

/** The route `/outreach/campaigns/:campaignUuid/review` (design outreach f1). */
const ReviewQueueViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { campaignUuid } = useParams<{ campaignUuid: string }>();
  if (accountId === null || campaignUuid === undefined) {
    return <LoadingView />;
  }
  return <ReviewQueueScreen accountId={accountId} campaignUuid={campaignUuid} />;
};

export const ReviewQueueView = TypedMemo(ReviewQueueViewComponent);
